import {
    GET_DELIVERY_CHALLAN_LIST_PROGRESS, GET_DELIVERY_CHALLAN_LIST_SUCCESS, GET_DELIVERY_CHALLAN_LIST_FAILURE,
    ADD_DELIVERY_CHALLAN_PROGRESS, ADD_DELIVERY_CHALLAN_SUCCESS, ADD_DELIVERY_CHALLAN_FAILURE,
    EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS, EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS, EDIT_DELETE_DELIVERY_CHALLAN_FAILURE,

    RESET_MESSAGE,
    GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS,
    GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE,
    GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,

} from '../../types/actionTypes';

const initialState = {
    deliveryChallan: [],
    lastEntryNo:null,
    deliveryChallan_itemDescription_forManualEntry: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const delivery_challan_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DELIVERY_CHALLAN_LIST_SUCCESS:
            return { ...state, deliveryChallan: action.deliveryChallan, lastEntryNo: action.deliveryChallan[0].challanNo, loading: false };
        case GET_DELIVERY_CHALLAN_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_DELIVERY_CHALLAN_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_DELIVERY_CHALLAN_PROGRESS:
            return { ...state, loading: true };
        case ADD_DELIVERY_CHALLAN_SUCCESS:
            return { ...state, deliveryChallan: [...state.deliveryChallan, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_DELIVERY_CHALLAN_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS:
            return {
                ...state,
                deliveryChallan: state.deliveryChallan.map((deliveryChallan) =>
                    deliveryChallan.id === action.payload.id ? action.payload : deliveryChallan
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_DELIVERY_CHALLAN_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS:
            return { ...state, deliveryChallan_itemDescription_forManualEntry: action.deliveryChallan_itemDescription_forManualEntry, loading: false };
        case GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS:
            return { ...state, loading: true, error: false };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default delivery_challan_reducer;